import { render, staticRenderFns } from "./SWSFooter.vue?vue&type=template&id=ac1c5cbe&scoped=true&"
import script from "./SWSFooter.vue?vue&type=script&lang=js&"
export * from "./SWSFooter.vue?vue&type=script&lang=js&"
import style0 from "./SWSFooter.vue?vue&type=style&index=0&id=ac1c5cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1c5cbe",
  null
  
)

export default component.exports